
import * as ActionTypes from 'constants';

export const ui = (state = {
	initializing : false,
	show_sidebar_container : true,
	show_tasks_sidebar: false
}, action) => {
	let { type, payload } = action

	switch(type) {
		case ActionTypes.TOGGLE_INIT_FLAG :
			return {...state, initializing : (payload !== undefined ? payload : !state.initializing)}
		case ActionTypes.TOGGLE_SHOW_SIDEBAR_CONTAINER :
			return {...state, show_sidebar_container : payload !== undefined ? payload : !state.show_sidebar_container}
		case ActionTypes.TOGGLE_SHOW_TASKS_SIDEBAR:
			return { ...state, show_tasks_sidebar: payload != null ? payload : !state.show_tasks_sidebar };
		default :
			return state
	}

	return state
}



// WEBPACK FOOTER //
// ./src/common/reducers/ui.js